import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { scrollToOffer } from '../utils/scrollToOffer';
export function StickyMobileCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      // Hide if we are near the bottom of the page to not overlap the final CTA
      const scrollY = window.scrollY;
      const isNearBottom = window.innerHeight + scrollY >= document.body.offsetHeight - 800;
      if (scrollY > 600 && !isNearBottom) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-92">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-5 bg-white/90 backdrop-blur-xl border-t border-gray-200 z-50 md:hidden shadow-[0_-10px_40px_rgba(0,0,0,0.1)]" data-id="element-93">
          <button onClick={scrollToOffer} className="w-full bg-black text-white font-black text-xl h-16 rounded-2xl flex items-center justify-center gap-2 active:scale-[0.98] transition-transform shadow-xl" data-id="element-94">
            Quiero más clientes
          </button>
        </motion.div>}
    </AnimatePresence>;
}